import {
    ChangeDetectionStrategy,
    Component, ElementRef,
    EventEmitter,
    inject,
    Input,
    OnChanges,
    Output,
    Renderer2, SimpleChanges, viewChild
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
    selector: 'div[app-drawer]',
    imports: [MatIconModule, NgClass],
    templateUrl: './drawer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerComponent implements OnChanges{
    private renderer = inject(Renderer2);
    closeIconRef = viewChild<ElementRef<HTMLButtonElement>>('closeIcon');

    @Input()
    public disabled: boolean = false;

    @Input()
    public isActive: boolean = false;

    @Output()
    public isActiveChange: EventEmitter<boolean> = new EventEmitter<boolean>();



    ngOnChanges(changes: SimpleChanges): void {
    const closeIcon = this.closeIconRef();

    if (changes['isActive']) {
    const isNowActive = changes['isActive'].currentValue;

    if (isNowActive) {
        closeIcon?.nativeElement.focus()
    }
}
}
    toggle(e: MouseEvent | TouchEvent | KeyboardEvent | Event) {
        console.log(e);
        console.log("toggling")
        e.stopPropagation();
        if (this.disabled) return;
        this.isActive = !this.isActive;
        this.isActiveChange.emit(this.isActive);
        this.renderer.setStyle(document.body, 'overflow', this.isActive ? 'hidden' : 'auto');
    }

    close(e: MouseEvent | TouchEvent | KeyboardEvent | Event) {
        console.log("closing");
        e.stopPropagation();
        if (this.isActive) {
            this.isActive = false;
            this.isActiveChange.emit(this.isActive);
            this.renderer.setStyle(document.body, 'overflow', 'auto');
        }
    }
}
